import React from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";

function Craftappsolution() {
  return (
    <section className="craftapp_solution tekrevol_dark_bg p-100 ">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <div className="craft_head_sticky">
              <h2>
                We Craft Regulatory-Compliant Healthcare Mobile App Solutions
              </h2>
              <p>
                Our team of healthcare mobile app developers is dedicated to
                crafting compliance-friendly platforms that prioritize mass care
                within digital healthcare processes. Recognizing the imperative
                need for international standard-compliant digital solutions, we
                ensure smooth digital transformation for healthcare systems
                worldwide and position us as a leading custom healthcare mobile
                app development company in the US.
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-md-1 services_faqs"
          >
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>HIPAA</Accordion.Header>
                <Accordion.Body>
                  <p>
                    As a US top-rated healthcare app development company, we
                    employ the best practices of confidentiality and data
                    security as mandated by HIPAA, including strong access
                    control mechanisms and encryption, for instance.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  HITECH (Health Information Technology for Economic and
                  Clinical Health)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Our healthcare apps comply with the HITECH (Health
                    Information Technology for Economic and Clinical Health)
                    Act. They successfully pass all security audits conducted to
                    assure 100% compliance with the HITECH-based privacy and
                    security requirements.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  SaMD (Software as a Medical Device)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    As pioneers in the medical software development industry, we
                    ensure the highest standards of confidentiality and
                    dependability in our applications. We prioritize patient
                    safety and efficacy in our innovative solutions, governed by
                    the International Medical Device Regulators Forum's (IMDRF)
                    SaMD risk categories.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  HL7 (Health Level Seven International)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    As a leading healthcare app development company, we adhere
                    to the widely accepted standards established by Health Level
                    Seven International for the effective sharing, exchange,
                    integration, and access of healthcare data. Our adherence to
                    these standards improves the handling of healthcare
                    information for greater efficiency.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  GDPR (General Data Protection Regulation)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    To comply with the rigorous requirements of GDPR, we
                    implement an extensive data collection and management
                    process in our healthcare application development to remain
                    compliant with the rigorous operational standards set forth
                    by GDPR.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  SOC 2 (Service Organization Control 2)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    While complying with SOC 2 rules, our main priority is to
                    preserve the highest security and privacy standards for your
                    medical records. In order to maintain the confidentiality
                    and accuracy of private health records, this framework's
                    primary objectives are to protect patient information.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  CPT (Current Procedural Terminology)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    We adhere to CPT (Current Procedural Terminology) in our
                    healthcare mobile app development services, which speeds up
                    the billing and coding process and ensures prompt payments
                    for medical services, hence minimizing paperwork for medical
                    providers.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  GxP Quality Guidelines and Regulations
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Our Compliance with Such Regulations builds a Foundation for
                    the highest level of quality during the healthcare
                    application development cycle. The GxP framework of GMP,
                    GLP, and GCP guidelines guarantees the high quality and
                    safety of pharmaceuticals, medical devices, and clinical
                    trials.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  Personal Health Information Protection Act (PHIPA)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    We abide by the Act PHIPA to guard patient privacy and
                    confidentiality, this creates trusted medical services
                    conditions. To safely obtain, utilize, and securely share
                    personal health information, medical professionals are
                    required to take notice of and obey PHIPA regulations.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10">
                <Accordion.Header>
                  DICOM (Digital Imaging and Communications in Medicine)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    To achieve 100% flawless integration of diagnostic software
                    with medical imaging systems, we strictly adhere to DICOM
                    (Digital Imaging and Communications in Medicine) compliance.
                    This standard provides a way for standardization of medical
                    imaging data transfer and management, which leads to
                    accuracy and interoperability in the healthcare diagnostics
                    and treatment planning process.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="11">
                <Accordion.Header>
                  FHIR (Fast Healthcare Interoperability Resources)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    As a leading healthcare application development company, we
                    employ FHIR compliance to embrace industry compatibility,
                    promoting easy communication between various healthcare
                    providers and enhancing patient care coordination.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="12">
                <Accordion.Header>
                  CDISC (Clinical Data Interchange Standards Consortium)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Being America’s best healthcare app development company, we
                    apply CDISC standards to guarantee that data acquisition,
                    handling, and reporting are consistent, increasing the
                    clinical research data interconnection and integrity.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="13">
                <Accordion.Header>
                  XDS/XDS-I (Cross-Enterprise Document Sharing)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    The implementation of XDS/XDS-I facilitates the exchange of
                    electronic health records among different healthcare
                    institutions using the controlled and secure transmission of
                    information, which ultimately improves interoperability.
                    This standard’s primary role is to ensure effective
                    communication and coordination which ultimately results in
                    better informed clinical decision making and better
                    coordination of patient care across the healthcare networks.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="14">
                <Accordion.Header>
                  SSAE (Statement on Standards for Attestation Engagements)
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Being a leading healthcare app development company, we, make
                    SSAE compliance a priority to establish and maintain the
                    security and legality of your healthcare services and
                    thereby ensure that your stakeholders receive the best level
                    of mean data confidentiality at every stage.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="16">
                <Accordion.Header>FDA</Accordion.Header>
                <Accordion.Body>
                  <p>
                    We adhere to the strict regulatory requirements set forth by
                    the FDA (Food and Drug Administration), which include
                    thorough documentation, stringent testing, and compliance
                    with Good Manufacturing Practices where appropriate.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Craftappsolution;
